import GlobalSnackbar from '@components/Shared/GlobalSnackbar.tsx';
import LoadingOverlay, { LoadingIndicator } from '@components/Shared/LoadingOverlay.tsx';
import { Box, Typography } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { store, persistor } from '@store/store.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App.tsx';
import './extensions';
import './index.css';
import { initializeApp } from './initApp.ts';

const root = createRoot(document.getElementById('root')!);

const fullScreen = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  backgroundColor: '#05070A'
} as const;

root.render(
  <Box sx={fullScreen}>
    <LoadingIndicator />
  </Box>
);

initializeApp()
  .then(() => {
    root.render(
      <StrictMode>
        <StyledEngineProvider injectFirst>
          <Provider store={store}>
            {/* Each surface applies AppTheme itself: the panel disables the custom input
                styling, the sign-in screen keeps it. */}
            <PersistGate loading={null} persistor={persistor}>
              <App />
              <GlobalSnackbar />
              <LoadingOverlay />
            </PersistGate>
          </Provider>
        </StyledEngineProvider>
      </StrictMode>
    );
  })
  .catch(error => {
    root.render(
      <Box sx={{ ...fullScreen, flexDirection: 'column', whiteSpace: 'pre-line' }}>
        <Typography color='white'>
          System cannot initialized. Try to refresh the page after few seconds.
        </Typography>
        {error?.toString() && <Typography color='red'>{error.toString()}</Typography>}
      </Box>
    );
  });
